module.exports = __webpack_public_path__ + "img/9600.63ebcdb2.jpg";